import { ChangeDetectionStrategy, Component, Input, OnDestroy, inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import {
  DataContextBuilder,
  ElderNumberCellDirective,
  ElderQuantityPipe,
  ElderTableComponent,
  IDataContext,
  Interval,
  IsoDurationPipe,
  Sort,
  SortUtil,
  Unit,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ViewModeContextService } from '../../../../context/view-mode-context/view-mode-context.service'
import { UtilisationCapacityBarComponent } from '../../utilisation-bar/utilisation-capacity-bar/utilisation-capacity-bar.component'
import { WorkCenterUtilisation } from '../../work-center-utilisation'
import {
  IWCUtilisationDialogOptions,
  WorkCenterUtilisationDetailDialogComponent,
} from '../../work-centers/work-center-utilisation-detail-dialog/work-center-utilisation-detail-dialog.component'

@Component({
  selector: 'app-work-center-utilisation-viewer',
  templateUrl: './work-center-utilisation-viewer.component.html',
  styleUrls: ['./work-center-utilisation-viewer.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    ElderNumberCellDirective,
    MatSortHeader,
    UtilisationCapacityBarComponent,
    ElderTranslatePipe,
    IsoDurationPipe,
    ElderQuantityPipe,
  ],
})
export class WorkCenterUtilisationViewerComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public data: IDataContext<WorkCenterUtilisation>
  public readonly Unit = Unit
  private matDialog = inject(MatDialog)
  private viewModeContext = inject(ViewModeContextService)

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set workCenterUtilisations(utilisations: WorkCenterUtilisation[]) {
    if (utilisations) {
      this.data = DataContextBuilder.start<WorkCenterUtilisation>()
        .localSort((data, sorts) => SortUtil.sortData(data, sorts))
        .buildLocal(utilisations)

      this.data.start([new Sort('workCenterNumber', 'asc')])
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(wutil: WorkCenterUtilisation): void {
    if (wutil) {
      this.matDialog.open(WorkCenterUtilisationDetailDialogComponent, {
        minWidth: '100vw',
        height: '100vh',
        data: <IWCUtilisationDialogOptions>{
          workCenterId: wutil.workCenterId,
          scheduleInterval: Interval.parse(wutil.scheduleInterval),
          viewMode: this.viewModeContext.viewMode,
        },
      })
    }
  }

  public percent(value: number): string {
    return Math.round(value * 100) + '%'
  }
}
